module.exports = __webpack_public_path__ + "static/media/zotero.6de06fc9.svg";